import {
  createContext, useContext,
} from 'react';
import { requestCategory, requestType } from '../../service/support';
import { Result, AsyncState } from '../../hooks/useAsyncFn';

export enum State {
  Start,
  Category,
  Type,
  Suggestion,
  Fill,
}

export const ContactContext = createContext<
| {
  category: AsyncState<Result<typeof requestCategory>>,
  type: AsyncState<Result<typeof requestType>>,
  values: Partial<{ regionCode: string, requestCategoryId: string, requestTypeId: string }>,
}
| undefined
>(undefined);

export function useContact() {
  const context = useContext(ContactContext);
  if (!context) {
    throw new Error();
  }
  return context;
}
